import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useBetaAvailability = () => {
  const { user, logout } = useAuth();
  const [showBetaModal, setShowBetaModal] = useState(false);

  useEffect(() => {
    if (user?.attributes) {
      const betaTester = user.attributes['custom:beta_tester'];
      
      // Show modal if beta_tester is explicitly set to 'false'
      // Missing or 'true' values are allowed (existing users + beta testers)
      if (betaTester === 'false') {
        console.log('🚫 Non-beta user detected, showing beta availability modal');
        setShowBetaModal(true);
      }
    }
  }, [user]);

  const closeBetaModal = () => {
    setShowBetaModal(false);
  };

  return {
    showBetaModal,
    closeBetaModal
  };
};